module.exports = __webpack_public_path__ + "static/media/linkbanner_sm3.b87c5fb3.png";